import { AlertIcon, CheckIcon, InfoIcon } from "./Icons";
import type { LayoutReport } from "../flasher/layout";

interface Props {
  report: LayoutReport;
  hasParts: boolean;
}

/**
 * Pre-flight layout findings. Errors here block the flash button, which is the
 * point: catching a wrong-chip binary before writing is far better than
 * explaining a boot loop afterwards.
 */
export function IssueList({ report, hasParts }: Props) {
  if (!hasParts) return null;

  if (report.issues.length === 0) {
    return (
      <div className="notice notice--success">
        <span className="notice__icon">
          <CheckIcon size={16} />
        </span>
        <div className="notice__body">
          <div className="notice__title">Layout checks passed</div>
          No overlaps, no chip mismatches, and every file has a valid address.
        </div>
      </div>
    );
  }

  return (
    <div className="stack">
      {report.issues.map((issue, index) => (
        <div key={`${issue.title}-${index}`} className={`notice notice--${issue.level}`}>
          <span className="notice__icon">
            {issue.level === "info" ? <InfoIcon size={16} /> : <AlertIcon size={16} />}
          </span>
          <div className="notice__body">
            <div className="notice__title">{issue.title}</div>
            {issue.detail}
          </div>
        </div>
      ))}
    </div>
  );
}
